<template>
  <div class="card" @click="handleClick">
    <div class="card-icon">
      <template v-if="isImageIcon">
        <img :src="icon" :alt="text" class="card-image-icon" />
      </template>
      <template v-else>
        <van-icon :name="icon" size="24" color="#1989fa" />
      </template>
    </div>
    <div class="card-text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    icon: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    isImageIcon: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      // this.$emit('click');
    }
  }
};
</script>

<style scoped>
.card {
  display: flex;
  align-items: center;
  margin: 15px 0; /* 上下各15px，中间间隔30px */
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  height: 90px !important;
  box-sizing: border-box;
}

.card-icon {
  margin-right: 15px;
}

.card-image-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.card-text {
  flex: 1;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

/* 大卡片样式 - 用于会议申请须知 */
.card.large {
  height: 120px;
  padding: 30px 18px;
}

.card.large .card-text {
  font-size: 18px;
}

.card.large .card-image-icon {
  width: 32px;
  height: 32px;
}
</style>